var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.089,
    height: 29.089,
    viewBox: "0 0 29.089 29.089",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#006ebb;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1555.5,243.56h5.8a.959.959,0,0,1,.959.959v5.795a.959.959,0,0,0,.959.959h3.225a.959.959,0,0,0,.959-.959v-5.795a.959.959,0,0,1,.959-.959h5.795a.959.959,0,0,0,.959-.959v-3.225a.959.959,0,0,0-.959-.959h-5.795a.959.959,0,0,1-.959-.959v-5.795a.959.959,0,0,0-.959-.959h-3.225a.959.959,0,0,0-.959.959v5.795a.959.959,0,0,1-.959.959h-5.8a.959.959,0,0,0-.959.959V242.6A.959.959,0,0,0,1555.5,243.56Z",
    transform: "translate(-1262.36 950.64) rotate(-45)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIcon);
export default __webpack_public_path__ + "static/media/x_icon.68df2222093dfe7b24941d26abb8cc10.svg";
export { ForwardRef as ReactComponent };